import(/* webpackMode: "eager" */ "/usr/src/syconium/packages/magnolia/src/app/(shop)/error.tsx");
